/**
 * Kept apart from dashboard-utils.ts, which imports dayjs: the app tests run
 * without `npm ci` (.github/workflows/verify-app-tests.yml), so the module
 * its test imports must import nothing.
 */
const DEFAULT_INVITE_URL = 'https://invite.agapae.gr';

/**
 * The invite app's address as configured (VITE_INVITE_URL), made usable: the
 * production address when it isn't set, `https://` added when it was written
 * without a scheme (`invite.agapae.gr`), no trailing slash. Pure, so it can be
 * tested without Vite or any package.
 */
export const normalizeInviteBaseUrl = (configured: string | null | undefined): string => {
  const value = (configured ?? '').trim().replace(/\/+$/, '');
  if (!value) return DEFAULT_INVITE_URL;
  return /^https?:\/\//i.test(value) ? value : `https://${value}`;
};
